import { createFileRoute } from '@tanstack/react-router';

import { AiFirstHarness } from '~/features/dev/ai-first-harness';

/** The AI-first frame against a real conversation, inside the app's shell. A developer page, reached only by its address. */
export const Route = createFileRoute('/_app/dev/ai-first')({ component: AiFirstHarness });
